<script setup lang="ts">
  import SearchIcon from '@/shared/assets/icons/SearchIcon.svg';
  import { IconImage } from '@/shared/ui';
</script>

<template>
  <div class="flex flex-1 flex-col items-center justify-center gap-2 text-center">
    <span class="text-[var(--theme-secondary-ink)]">
      <IconImage :src="SearchIcon" alt="Nenhum resultado encontrado" class="h-6 w-6" />
    </span>
    <p class="text-xl font-semibold text-gray-07">Nenhum resultado encontrado</p>
  </div>
</template>
